import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { useNavigate, useParams } from 'react-router-dom';
import { Table, Button, notification, DatePicker, Input } from 'antd';
import { DownloadOutlined, SearchOutlined } from '@ant-design/icons';
import { PageContainer } from '@ant-design/pro-layout';
import dayjs from 'dayjs';
import { AuthContext } from 'context/AuthContext';
import reportService from 'services/report.service';
import { formatDateForClient, formatDateForServer, formatMoney } from 'helpers/utils';
import { storage } from 'helpers';
import download from 'js-file-download';
import reportTypes from '../../../helpers/reportTypes';

const { RangePicker } = DatePicker;

const renderFilterDropdown = ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
  <div style={{ padding: 8 }}>
    <Input
      placeholder="Gün Sonu ID Ara"
      value={selectedKeys[0]}
      onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
      onPressEnter={() => confirm()}
      style={{ width: 188, marginBottom: 8, display: 'block' }}
    />
    <Button
      type="primary"
      onClick={() => confirm()}
      icon={<SearchOutlined />}
      size="small"
      style={{ width: 90, marginRight: 8 }}
    >
      Ara
    </Button>
    <Button onClick={() => clearFilters()} size="small" style={{ width: 90 }}>
      Temizle
    </Button>
  </div>
);

class EodReportByTerminal extends Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      reports: [],

      loading: false,
      startDate: storage.get('date-filters')
        ? storage.get('date-filters').startDate
        : formatDateForClient(dayjs().subtract(365, 'days')),
      endDate: storage.get('date-filters')
        ? storage.get('date-filters').endDate
        : formatDateForClient(),
      currentMerch: context?.selectedMerch,
      columns: [
        {
          title: <div className="table-title-calibri-bold-12">Şube Bilgisi</div>,
          dataIndex: 'BranchId',
          key: 'Branch',
          align: 'center',
          render: (text, row) => {
            return (
              <span className="table-title-calibri-bold-12">
                {row.BranchName ? row.BranchName : ''} - {row.BranchId ? row.BranchId : ''}
              </span>
            );
          },
        },
        {
          title: <div className="table-title-calibri-bold-12">Terminal Bilgisi</div>,
          dataIndex: 'SicilNumber',
          key: 'SicilNumber',
          align: 'center',
          render: (text, row) => {
            return (
              <div style={{ textAlign: 'center' }}>
                <span className="table-content-calibri-bold-11">
                  {' '}
                  {'Sicil No: '}
                  {row.TerminalSicilNumber ? row.TerminalSicilNumber : ''} <br />{' '}
                </span>
                <span className="table-content-calibri-light-11">
                  {' '}
                  {'  Terminal No: '}
                  {row.TerminalNumber ? row.TerminalNumber : ''}
                </span>
              </div>
            );
          },
        },
        {
          title: <div className="table-title-calibri-bold-12">İşlem Bilgisi</div>,
          dataIndex: 'ActionNumber',
          key: 'ActionNumber',
          align: 'center',
          render: (text, row) => {
            return (
              <div style={{ textAlign: 'center' }}>
                <span className="table-title-calibri-bold-12">
                  {' '}
                  {row.TxnTypeName ? row.TxnTypeName : ''} <br />{' '}
                </span>
                <span className="table-content-calibri-light-12">
                  {' '}
                  {'  İşlem No: '}
                  {row.TxnId ? row.TxnId : ''}
                </span>
              </div>
            );
          },
        },
        {
          title: <span className="table-title-calibri-bold-12">Tutar</span>,
          dataIndex: 'Amount',
          key: 'Amount',
          align: 'center',
          render: (text, row) => {
            return (
              <span className="table-title-calibri-bold-12">{`${formatMoney(row.Amount)} TL`}</span>
            );
          },
        },
        {
          title: <div className="table-title-calibri-bold-12">İşlem Tarihi</div>,
          dataIndex: 'ActionDate',
          key: 'ActionDate',
          align: 'center',
          render: (text, row) => {
            return (
              <span className="table-title-calibri-bold-12">
                {dayjs(row.Date).format('DD.MM.YYYY HH:mm')}
              </span>
            );
          },
        },
        /* {
          title: <div className="table-title-calibri-bold-12" >Gün Sonu Bilgisi</div>,
          dataIndex: 'AgreementId',
          key:'Eod',
          align: 'center',
          render: (text,row) => {
          return <div style={{textAlign: 'center'}}>
                   <span className="table-title-calibri-bold-12">{dayjs(row.EodDate).format('DD.MM.YYYY HH:MM')} <br /> </span>
                   <span className="table-content-calibri-light-12">{'Gün Sonu ID:  '}{row.EodId} </span>
            </div>
          }
        }
        */
        {
          title: <div className="table-title-calibri-bold-12">Gün Sonu ID</div>,
          dataIndex: 'EodId',
          key: 'EodId',
          align: 'center',
          onFilter: (value, record) => record?.EodId?.toString()?.indexOf(value) === 0,
          filterDropdown: renderFilterDropdown,
          render: (text, row) => {
            return (
              <div style={{ textAlign: 'center' }}>
                <span className="table-title-calibri-bold-12">{row.EodId} </span>
              </div>
            );
          },
        },
        {
          title: <div className="table-title-calibri-bold-12">Gün Sonu Tarihi</div>,
          dataIndex: 'EodDate',
          key: 'EodDate',
          align: 'center',
          width: '160px',
          render: (text, row) => {
            return (
              <div className="text-align-center">
                <span className="table-title-calibri-bold-12">
                  {dayjs(row.EodDate).format('DD.MM.YYYY HH:mm')}{' '}
                </span>
                <br />
              </div>
            );
          },
        },
      ],
    };
  }

  componentDidMount() {
    this.fetchReports();
  }

  componentDidUpdate(prevProps, prevState) {
    if (
      prevState?.currentMerch?.number !== this.context?.selectedMerch?.number &&
      this.state?.currentMerch?.number === prevState.currentMerch?.number
    ) {
      this.fetchReports();
    }
  }

  fetchReports = async () => {
    this.setState({ loading: true, currentMerch: this.context?.selectedMerch }, async () => {
      try {
        const { currentMerch, endDate, startDate } = this.state;
        if (currentMerch?.number) {
          const { branchId, terminalId } = this.props.params;
          const { payload } = await reportService.getEodReportsByTxn(
            currentMerch?.number,
            branchId,
            terminalId,
            formatDateForServer(startDate),
            formatDateForServer(endDate),
          );
          this.setState({ loading: false, reports: payload });
        }
      } catch (error) {
        this.setState({ loading: false, reports: [] });
        notification.error({
          message: 'İşlem Başarısız',
          description: error,
        });
      }
    });
  };

  onDateChange = (dates) => {
    if (!dates || dates.length !== 2) return;
    const startDate = formatDateForClient(dates[0]);
    const endDate = formatDateForClient(dates[1]);
    this.setState({ startDate, endDate }, () => {
      storage.set({ startDate, endDate }, 'date-filters');
      this.getReports();
    });
  };

  downloadExcel = async () => {
    try {
      this.setState({ downloading: true });
      const { currentMerch, startDate, endDate } = this.state;
      const { branchId, terminalId } = this.props.params;
      const data = await reportService.getEodReportsExcel(
        currentMerch?.number,
        reportTypes.EOD_TRANSACTION,
        branchId,
        terminalId,
        formatDateForServer(startDate),
        formatDateForServer(endDate),
      );
      download(
        data,
        `IslemBazliGunSonuRaporu-${currentMerch?.number}-${branchId}-${terminalId}-${dayjs().format('DD-MM-YYYY')}.xls`,
      );
      this.setState({ downloading: false });
    } catch (error) {
      this.setState({ loading: false, downloading: false });
      notification.error({
        message: 'İşlem Başarısız',
        description: error,
      });
    }
  };

  render() {
    const { reports, columns, loading, currentMerch, startDate, endDate, downloading } = this.state;
    return (
      <>
        <PageContainer
          style={{ paddingBottom: 0 }}
          title="İşlem Bazında Günsonu Raporu"
          extra={[
            <RangePicker
              allowClear={false}
              defaultValue={[dayjs(startDate, 'DD.MM.YYYY'), dayjs(endDate, 'DD.MM.YYYY')]}
              key="eod"
              onChange={this.onDateChange}
              format="DD.MM.YYYY"
            />,
            <Button
              loading={downloading}
              disabled={loading || downloading}
              key="1"
              type="primary"
              icon={<DownloadOutlined />}
              onClick={() => {
                this.downloadExcel();
              }}
            >
              İndir
            </Button>,
          ]}
        />
        <PageContainer
          style={{ paddingTop: 0 }}
          title=""
          subTitle={`${currentMerch?.number} ${currentMerch?.type}'li işlem Bazlı Günsonu Raporu`}
        >
          <Table
            loading={loading}
            dataSource={reports}
            columns={columns}
            pagination
            rowKey={(record, index) => index}
          />
        </PageContainer>
      </>
    );
  }
}

EodReportByTerminal.contextType = AuthContext;

const EodReportByTerminalWrapper = (props) => {
  const params = useParams();
  const navigate = useNavigate();
  return <EodReportByTerminal {...props} params={params} navigate={navigate} />;
};

EodReportByTerminal.propTypes = {
  params: PropTypes.shape({
    branchId: PropTypes.string,
    terminalId: PropTypes.string,
  }).isRequired,
};

export default EodReportByTerminalWrapper;
